import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function EmailChangePending() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const pendingEmail = searchParams.get('email') || '';

  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleResend = async () => {
    setResending(true);
    setMessage({ type: '', text: '' });

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/resend-email-change-verification`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      setMessage({ type: 'success', text: 'Verification email resent! Please check your inbox.' });
    } catch (error) {
      const errorDetail = error.response?.data?.detail || 'Failed to resend verification email';
      setMessage({ type: 'error', text: errorDetail });
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Verify Your New Email
          </h2>
        </div>

        <div className="mt-8 bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-4">
              <svg className="h-8 w-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>

            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Check Your Email
            </h3>

            <p className="text-gray-600 mb-2">
              We've sent a verification link to:
            </p>

            {pendingEmail && (
              <p className="text-blue-600 font-medium mb-4">
                {pendingEmail}
              </p>
            )}

            <p className="text-gray-500 text-sm mb-6">
              Click the link in the email to confirm your new email address.
              The link will expire in 24 hours.
            </p>

            {message.text && (
              <div className={`mb-4 p-3 rounded-lg ${
                message.type === 'success'
                  ? 'bg-green-50 text-green-800 border border-green-200'
                  : 'bg-red-50 text-red-800 border border-red-200'
              }`}>
                {message.text}
              </div>
            )}

            <div className="space-y-3">
              <button
                onClick={handleResend}
                disabled={resending}
                className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition font-medium"
              >
                {resending ? 'Sending...' : 'Resend Verification Email'}
              </button>

              <button
                onClick={() => navigate('/profile/settings')}
                className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
              >
                Back to Settings
              </button>
            </div>

            <p className="mt-6 text-gray-500 text-sm">
              Didn't receive the email? Check your spam folder or click resend above.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
